var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8813 10.5126C4.79039 10.5126 3.91766 11.3853 3.91766 12.4762C3.91766 13.5671 4.79039 14.4398 5.8813 14.4398C6.97221 14.4398 7.84494 13.5671 7.84494 12.4762C7.89948 11.3853 6.97221 10.5126 5.8813 10.5126Z",
    stroke: "currentColor",
    fill: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0994 10.5126C11.0085 10.5126 10.1358 11.3853 10.1358 12.4762C10.1358 13.5671 11.0085 14.4398 12.0994 14.4398C13.1903 14.4398 14.0631 13.5671 14.0631 12.4762C14.0631 11.3853 13.1903 10.5126 12.0994 10.5126Z",
    stroke: "currentColor",
    fill: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3177 10.5126C17.2268 10.5126 16.3541 11.3853 16.3541 12.4762C16.3541 13.5671 17.2268 14.4398 18.3177 14.4398C19.4086 14.4398 20.2813 13.5671 20.2813 12.4762C20.2813 11.3853 19.4086 10.5126 18.3177 10.5126Z",
    stroke: "currentColor",
    fill: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreicon);
export default __webpack_public_path__ + "static/media/more.icon.7e6fb93cd53001660d053ce8b86b0508.svg";
export { ForwardRef as ReactComponent };